import * as types from "./faqActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  faqList: {},
  error: null,
  isError: false
};

const initialState = {
  faq: {
    ...stateObject
  }
};

export default function faqReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_FAQ_LOADING:
      return {
        ...state,
        faq: {
          ...state.faq,
          isLoading: true
        }
      };
    case types.GET_FAQ_SUCCESS:
      return {
        ...state,
        faq: {
          ...state.faq,
          isLoading: false,
          isSuccess: true,
          error: null,
          faqList: action.payload.faq
        }
      };
    case types.GET_FAQ_FAILURE:
      return {
        ...state,
        faq: {
          ...state.faq,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    default:
      return state;
  }
}
